'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_api_AfterLoginResponse(existingUser) {
  this.Xc = null;
  this.Xc = existingUser;
}
export { $c_Lapp_api_AfterLoginResponse as $c_Lapp_api_AfterLoginResponse };
$p = $c_Lapp_api_AfterLoginResponse.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_api_AfterLoginResponse;
/** @constructor */
function $h_Lapp_api_AfterLoginResponse() {
}
export { $h_Lapp_api_AfterLoginResponse as $h_Lapp_api_AfterLoginResponse };
$h_Lapp_api_AfterLoginResponse.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_AfterLoginResponse)) {
    var x = this.Xc;
    var x$2 = x$0.Xc;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "AfterLoginResponse";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Xc;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "existingUser";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_AfterLoginResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ic)));
}
export { $isArrayOf_Lapp_api_AfterLoginResponse as $isArrayOf_Lapp_api_AfterLoginResponse };
var $d_Lapp_api_AfterLoginResponse = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_api_AfterLoginResponse, "app.api.AfterLoginResponse", ({
  ic: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_api_AfterLoginResponse as $d_Lapp_api_AfterLoginResponse };
//# sourceMappingURL=app.api.-After-Login-Response.js.map
